module.exports = "<p>\n  all-games works!\n</p>\n"